import IconTrashBin from "assets/img/icon-trash-bin.svg?react"

import { FC } from "react"

import { Flex, FlexItem } from "components/Flex"
import { Grid, GridItem } from "components/Grid"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import { getFileNameAndExtension } from "utils/utils"
import Button from "components/Button/Button"

interface IAddDocumentsDocumentProps {
    file: File
    onDelete(): void
    isDisabled?: boolean
}

const AddDocumentsDocument: FC<React.PropsWithChildren<IAddDocumentsDocumentProps>> = ({
    file,
    onDelete,
    isDisabled,
}) => {
    const { name, extension } = getFileNameAndExtension(file.name)

    return (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            className="border-grey-100-between py-1">
            <Grid columns="minmax(0, 100%) max-content">
                <GridItem>
                    <FlexibleContent text={name} clamp={1} />
                </GridItem>
                <GridItem>.{extension}</GridItem>
            </Grid>
            <FlexItem shrink={0} className="ml-2">
                <Button
                    theme="transparent"
                    round
                    onClick={onDelete}
                    disabled={isDisabled}
                    icon={<IconTrashBin />}
                />
            </FlexItem>
        </Flex>
    )
}

export default AddDocumentsDocument
